import { Navigate, useNavigate } from 'react-router-dom'
import { PAYMENT_FIELDS } from './enum'
import { NOTIFICATION_TYPE } from '@utils/enum'
import useNotify, {
  NotificationDuration,
  NotificationEnums,
} from '@api/hooks/ambassdor/useNotify'
import { locationEnabled } from './translation'
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { Meta, Teacher } from '@components/Sales/type'
import { format } from "date-fns";
import { BatchPlan, BatchPlus, PLAN_BADGE } from '@components/Sales/batch.type'
import { BEST_TAG, POPULAR_TAG, RECOMMENDED_TAG } from '@assets/images/location/ASSETS_IMAGES'

const { showNotification } = useNotify()

export const NumberShortText = (num: number, digits = 2) => {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  let item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value
    })
  return item
    ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
    : '0'
}
export const parseMutationObject = (data: any) => {
  if (typeof data === 'string') {
    return data
  }
  if (data) {
    return JSON.parse(JSON.stringify(data))
  }
  return null
}
export const getImageUrlFromObjectImageId = (
  imageObject: any,
  defaultImage?: any
) => {
  if (imageObject?.baseUrl && imageObject?.key) {
    return imageObject?.baseUrl + imageObject?.key
  }
  return defaultImage || 'https://www.pw.live//version14/assets/img/logo.png'
}
export const getAssetUrlFromObjectAssetId = (
  imageObject: any,
  defaultImage?: any
) => {
  if (imageObject?.baseUrl && imageObject?.key) {
    return imageObject?.baseUrl + imageObject?.key
  }
  return defaultImage || 'https://www.pw.live//version14/assets/img/logo.png'
}
export const generateWhatsappLink = (batchSlug: string) => {
  const urlEncodedText = encodeURI(
    `Looking for quality education content at an affordable prices? Check out this course from PhysicsWallah and get enrolled to crack the toughest exams with best in class study material and top rated faculties. : https://www.pw.live/k8/batches/${batchSlug}`
  )
  return `https://api.whatsapp.com/send?text=${urlEncodedText}`
}

export const truncateString = (str: string, limit: number): string => {
  return str.length > limit ? str.slice(0, limit) + '...' : str
}

export const downloadFile = (url: string, fileName: string) => {
  fetch(url).then((response) => {
    response.blob().then((blob) => {
      // Creating new object of PDF file
      const fileURL = window.URL.createObjectURL(blob)
      // Setting various property values
      let alink = document.createElement('a')
      alink.href = fileURL
      alink.download = `${fileName}.pdf`
      alink.click()
    })
  })
}

export const modifyMeta = (meta: any) => {
  const newMeta = meta.map((m: any) => {
    const str = m.key.split('_').join(' ').toLowerCase()
    return {
      ...m,
      key: str,
    }
  })
  return newMeta
}

export const textGradientStyles = {
  background: 'linear-gradient(90deg, #D2CCFF 0%, #EDB84F 100%)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}

export const isLoginPhoneValid = (phone: string) => {
  const _text = phone || ''
  if (_text?.length === 10) {
    let pattern = /^(?:[6-9]\d{9})?$/
    return pattern.test(_text)
  }
  return true
}

export const containsCharacters = (input: string) => {
  const _text = input || ''
  let checkChar = new RegExp('^[0-9]+$')
  if (!checkChar.test(_text)) return true
}

export const isPhoneValid = (phone: string) => {
  const _text = phone || ''
  let pattern = /^[6-9]\d{9}$/
  return pattern.test(_text)
}

export function displayTextLimiter(text: string, count: number) {
  const ext = text.endsWith('.pdf') ? '.pdf' : '.jpeg'
  return text.slice(0, count) + (text.length > count ? '...' + ext : '')
}

export const getErrorMessage = (field: PAYMENT_FIELDS) => {
  switch (field) {
    case PAYMENT_FIELDS.BANK_ACCOUNT_NUMBER:
      return 'Please enter valid Bank Account Number'
    case PAYMENT_FIELDS.BANK_HOLDER_NAME:
      return `Please enter valid Name`
    case PAYMENT_FIELDS.BANK_NAME:
      return `Please enter a valid Branch Name`
    case PAYMENT_FIELDS.IFSC_CODE:
      return `Please enter valid Ifsc Code`
    case PAYMENT_FIELDS.BANK_BRANCH:
      return `Please enter a valid Bank Branch Name`
    case PAYMENT_FIELDS.PAN_CARD_NUMBER:
      return `Please enter a valid Pan Card Number`
    case PAYMENT_FIELDS.PASSBOOK:
      return `Please enter valid a file`
    case PAYMENT_FIELDS.PAN_CARD:
      return `Please enter valid a file`
    case PAYMENT_FIELDS.PASSPORT:
      return `Please enter valid a file`
    case PAYMENT_FIELDS.GST_CERTIFICATE:
      return `Please enter valid a file`
    default:
      return `Field cannot be empty.`
  }
}

export const isValid = (
  field: PAYMENT_FIELDS,
  value: any,
  verifyIFSC: boolean
) => {
  switch (field) {
    case PAYMENT_FIELDS.BANK_ACCOUNT_NUMBER:
      return (
        new RegExp(/^[0-9]+$/).test(value) &&
        value.length >= 9 &&
        value.length <= 18 &&
        !new RegExp(/^[0]+$/).test(value)
      )
    case PAYMENT_FIELDS.BANK_HOLDER_NAME:
      return (
        new RegExp(/^([a-zA-Z]+\s)*[a-zA-Z]+$/).test(value.trim()) &&
        value.length > 2 &&
        value.length < 101
      )
    case PAYMENT_FIELDS.BANK_NAME:
      // return new RegExp(/^([a-zA-Z]+\s)*[a-zA-Z]+$/).test(value.trim())
      return value.length > 0
    case PAYMENT_FIELDS.BANK_BRANCH:
      return value.length > 0
    // return new RegExp(/^[a-zA-Z0-9]*$/).test(value.trim())
    case PAYMENT_FIELDS.IFSC_CODE:
      return value.length >= 11 && verifyIFSC
    case PAYMENT_FIELDS.PAN_CARD_NUMBER:
      return (
        value.length === 10 &&
        new RegExp(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}/).test(value)
      )
    case PAYMENT_FIELDS.PAN_CARD:
      return value.length > 0
    case PAYMENT_FIELDS.GST_CERTIFICATE:
      return true
    case PAYMENT_FIELDS.PASSBOOK:
      return value.length > 0
    case PAYMENT_FIELDS.PASSPORT:
      return value.length > 0
    default:
      return true
  }
}

export const covertArrayEleToString = (data: string[]) => {
  const len = data.length
  let s = ''
  for (let i = 0; i < len; i++) {
    s += data[i]
    if (i !== len - 1) {
      s += ','
    }
  }
  return s
}

export const dateFormat = (olddate: string) => {
  const date = new Date(olddate)
  let year = date.getFullYear()
  let month: any = date.getMonth() + 1
  let dt: any = date.getDate()

  if (dt < 10) {
    dt = '0' + dt
  }
  if (month < 10) {
    month = '0' + month
  }
  return `${dt}/${month}/${year}`
}

export const covertIntoBlackSlashSeparatedValues = (arr: string[]) => {
  if (arr.length === 0) return ''
  if (arr.length === 1) return arr[0]
  else {
    let resultValue = ''
    for (let i = 0; i < arr.length - 1; i++) {
      resultValue += arr[i]
      resultValue += '/'
    }
    resultValue += arr[arr.length - 1]
    return resultValue
  }
}

export const covertPanCardNum = (num: string) => {
  let startPart = num.substring(0, 5).toUpperCase()
  let middlePart = num.substring(5, 9)
  let endPart = num.substring(9, 10).toUpperCase()
  const res: string = startPart + middlePart + endPart
  return res
}

export const urlKey = (urlLink: string) => {
  const key = urlLink?.split('/')[3].split('?')[0]
  return key
}

export const Notification = (
  message: string,
  type: string,
  variant?: 'white' | 'black'
) => {
  if (type === NOTIFICATION_TYPE.ERROR) {
    return showNotification({
      type: NotificationEnums.ERROR,
      title: message || 'Something went wrong',
      duration: NotificationDuration.SHORT,
      variant: variant,
    })
  } else if (type === NOTIFICATION_TYPE.SUCCESS) {
    return showNotification({
      type: NotificationEnums.SUCCESS,
      title: message || 'Succeed!',
      duration: NotificationDuration.SHORT,
      variant: variant,
    })
  }
}

export const isLoginUserFullNameValid = (name: string) => {
  const _text = name || ''
  let pattern = new RegExp(/^([a-zA-Z]+\s)*[a-zA-Z]+$/).test(_text.trim())
  if (pattern && _text.length > 1 && _text.length < 101) return true
}

export const isEmailIsValid = (name: string) => {
  const _text = name || ''
  let pattern = new RegExp(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  ).test(_text.trim())
  if (pattern && _text.length > 2) return true
}

export const isEmailOTPIsValid = (name: string) => {
  const _text = name || ''
  let pattern = new RegExp(/^[0-9]/).test(_text.trim())
  if (pattern && _text.length === 6) return true
}

export const locationStatusCheck = (navigate: any) => {
  if (localStorage.getItem(locationEnabled)) {
    const val = JSON.parse(localStorage.getItem(locationEnabled) || '')
    if (!val) {
      navigate('/dashboard')
    }
  }
}

export const removeActiveTab = () => {
  if (typeof window !== "undefined") {
    return localStorage.removeItem("activeTab");
  }
};

export function getImageByBaseUrlAndKey(baseUrl: string, key: string): string {
  if (!baseUrl || !key) return "";

  return baseUrl + key;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const getCDNAssetUrl = (relPath: string): string => {
  return `https://static.pw.live/react-batches/${relPath}`;
};

export function getPrice(price: number, amountTitle: string | undefined) {
  if (!price) return typeof amountTitle !== "string" ? "Free" : amountTitle;

  return `₹ ${Math.round(price)}`;
}

export function isValidDate(dateObject: Date) {
  const parsedDate = new Date(dateObject);

  return parsedDate instanceof Date && !isNaN(parsedDate.getTime());
}

export const userInfo = () => {
  if (typeof window !== "undefined") {
    return JSON.parse(localStorage.getItem("user") || "{}");
  }
  return null;
};


const generateString = (
  data: any[],
  prefix: string,
  separator: string = " | ",
  key: string,
) => {
  if (!data || data.length === 0) return "";
  return `${prefix}${data.map((item) => item?.[key]).join(separator)}\n`;
};

export const generateWhatsappLinkBatch = (
  date: Date,
  imageUrl: string,
  meta: Meta[],
  teachers: Teacher[],
  exam: string,
  fee: number,
  batchSlug: string,
  cohortId: string,
) => {
  const userId = userInfo ? userInfo()?.id : "";
  const urlEncodedText = encodeURI(
    `  Check out this *${exam}* course from PhysicsWallah! \n\
      \n\ *Batch Details:-* \n\
☑️  Start on ${format(new Date(date), "MMM do")}  \n\
${generateString(meta, "☑️  ", " | ", "key")}
Batch Price - *₹${fee}* \n\
      \n\ Explore More Details here 👇👇 - \n\
https://www.pw.live/study/batches/${batchSlug}/batch-overview?referred_by=${userId}&cohortId=${cohortId}
      `,
  );
  return `https://api.whatsapp.com/send?text=${urlEncodedText}`;
};


export const shareOnWhatsapp = (
  date: Date,
  imageUrl: string,
  meta: Meta[],
  teachers: Teacher[],
  exam: string,
  fee: number,
  batchSlug: string,
  cohortId: string,
) => {
  const url: string = generateWhatsappLinkBatch(
    date,
    imageUrl,
    meta,
    teachers,
    exam,
    fee,
    batchSlug,
    cohortId,
  );
  window?.open(url, "_blank");
};

export const findLastIndex = (arr: any[], condition: (ele: any) => boolean) => {
  for (let i = arr.length - 1; i >= 0; i--) {
    if (condition(arr[i])) {
      return i;
    }
  }
  return -1;
};

export function shareToWhatsApp(link: string) {
  const invoiceLink = link
  const encodedLink = encodeURIComponent(invoiceLink)
  const whatsapURL =
    'https://web.whatsapp.com/send?text=here is the invoice:' + encodedLink
  window.open(whatsapURL)
}

export const downloadInvoice = (filename: string, url: string) => {
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = `${filename}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(blobUrl)
    })
}

export const getPlusDefaultPlan = (plansData: BatchPlus): BatchPlan => {
  let activeIndex = 0;
  let lastPurchasedPlanIdx = findLastIndex(
    plansData?.plans,
    (plan: BatchPlan) => plan?.isPlanPurchased,
  );

  activeIndex =
    lastPurchasedPlanIdx < plansData.plans.length - 1
      ? lastPurchasedPlanIdx + 1
      : lastPurchasedPlanIdx;
  return plansData?.plans?.[activeIndex] ?? new BatchPlan({});
};

export const showPlanBadge = (plan: BatchPlan) => {
  if (plan?.planBadges !== PLAN_BADGE.NONE) {
    switch (plan?.planBadges) {
      case PLAN_BADGE.BEST:
        return getCDNAssetUrl(BEST_TAG);
      case PLAN_BADGE.RECOMMENDED:
        return getCDNAssetUrl(RECOMMENDED_TAG);
      case PLAN_BADGE.POPULAR:
        return getCDNAssetUrl(POPULAR_TAG);
      default:
        return "";
    }
  }
  return null;
};

export const argbToRgba = (argbHex: string) => {
  if (!argbHex) {
    return "#00000000";
  }

  argbHex = argbHex.startsWith("#") ? argbHex.slice(1) : argbHex;

  let alpha = argbHex.slice(0, 2);
  let red = argbHex.slice(2, 4);
  let green = argbHex.slice(4, 6);
  let blue = argbHex.slice(6, 8);
  return "#" + red + green + blue + alpha;
};


export const getPlansDivWidth = (plansCount: number) => {
  if (plansCount > 3) {
    return { div1Width: 53, div2Width: 47 };
  }

  const clampedPlansCount = Math.min(plansCount, 3);

  const div1Width = 80 - 10 * (clampedPlansCount - 1);
  const div2Width = 100 - div1Width;

  return { div1Width, div2Width };
};
export const formattedDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

const formatFullName = (first = '', last = '') => {
  const f = first.trim()
  const l = last.trim()
  return f && l ? `${f} ${l}` : f || l || 'Unknown User'
}

export const getUserDisplayName = (bankHolderName?: string, firstName?: string, lastName?: string) => {
  const name = bankHolderName || ''
  if (name) return name
  return formatFullName(firstName, lastName)
}